<div
    class="agpr-mentionInsightUpsellCard"
    [class.expanded]="!isCollapsed"
    [ngClass]="{
        'agpr-mentionInsightUpsellCard--light': !isWhiteLabeledBrand,
        'agpr-mentionInsightUpsellCard--primary': isWhiteLabeledBrand
    }"
>
    <agpr-panel
        [collapsed]="true"
        (collapsedChange)="isCollapsed = $event;"
        [marginTop]="0"
    >
        <ng-template #panelHeader>
            <div class="agpr-mentionInsightUpsellCard-heading">
                <span
                    class="agpr-mentionInsightUpsellCard-icon fa-kit-duotone fa-agpr-insights"
                    aria-hidden="true"
                ></span>
                <span>
                    {{ 'Mention.insights.upsell.heading' | localize}}
                </span>
            </div>
        </ng-template>
        <div class="agpr-mentionInsightUpsellCard-content">
            <div class="agpr-mentionInsightUpsellCard-message">
                {{ 'Mention.insights.upsell.message' | localize}}
            </div>
            <div
                class="agpr-mentionInsightUpsellCard-toggleWrapper"
            >
                <ul class="agpr-mentionInsightUpsellCard-messageBullets">
                    <li>{{ 'Mention.insights.upsell.message.bullet1' | localize}}</li>
                    <li>{{ 'Mention.insights.upsell.message.bullet2' | localize}}</li>
                    <li>{{ 'Mention.insights.upsell.message.bullet3' | localize}}</li>
                </ul>
            </div>
            <div class="agpr-mentionInsightUpsellCard-footer">
                <agpr-button
                    [id]="id + '_unlock'"
                    class="agpr-mentionInsightUpsellCard-button"
                    label="Mention.insights.upsell.unlock"
                    ariaLabel="Mention.insights.upsell.message.callForAction"
                    [style]="buttonTypes.primary"
                    (click)="unlock()"
                ></agpr-button>
            </div>
        </div>
    </agpr-panel>
</div>
